export default __webpack_public_path__ + "static/media/eliqx-logo-blue.38c56441.svg";